import { render, staticRenderFns } from "./UiBlockTreePicker.vue?vue&type=template&id=ba12ba4a&scoped=true"
import script from "./UiBlockTreePicker.vue?vue&type=script&lang=js"
export * from "./UiBlockTreePicker.vue?vue&type=script&lang=js"
import style0 from "./UiBlockTreePicker.vue?vue&type=style&index=0&id=ba12ba4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba12ba4a",
  null
  
)

export default component.exports